var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"download",attrs:{"src":require("@/assets/images/download.png"),"alt":""},on:{"click":_vm.download}})])}
var staticRenderFns = []

export { render, staticRenderFns }